var jcsfApp;
(function (jcsfApp) {
	var app;
	(function (app) {
		var profile;
		(function (profile) {
			var ProfileController = (function () {
				function ProfileController(
					$scope,
					authService,
					constantService,
					dataService
				) {
					this.authService = authService;
					this.constantService = constantService;
					this.dataService = dataService;

					authService.fillAuthData();

					this.profile = structuredClone(authService.authentication.userInfo);
					if (
						this.authService.authentication.userName == null ||
						!this.authService.authentication.isAuth
					) {
						$scope.$state.go('login');
					}
				}

				ProfileController.prototype.cancel = function () {
					this.profile = structuredClone(
						this.authService.authentication.userInfo
					);
				};

				ProfileController.prototype.save = function () {
					var $this = this;
					var modifier = this.authService.authentication.userName;
					this.LastModifiedBy = modifier;
					delete this.profile.Roles;
					this.dataService
						.update(
							this.constantService.apiProfileURI + this.profile.UserId,
							this.profile
						)
						.then(function (result) {
							$this.profile = result;
							$this.authService.updateProfile($this.profile);
						});
				};

				ProfileController.$inject = [
					'$scope',
					'authService',
					'constantService',
					'dataService',
				];

				return ProfileController;
			})();
			profile.ProfileController = ProfileController;
			angular
				.module('jcsfApp')
				.controller('ProfileController', ProfileController);
		})((profile = app.profile || (app.profile = {})));
	})((app = jcsfApp.app || (jcsfApp.app = {})));
})(jcsfApp || (jcsfApp = {}));
